<template>
  <div>
    <a-form label-width="100px" label-position="left">
      <DataAuth v-model="dataAuth" @clearOthers="clearOthers" ref="dataAuth" @datachange="datachange" :dataSet="dataSet" :chartType="chartType"
      ></DataAuth>
      <template v-if="chartType !=='widget-filter' && chartType !=='screen'">
        <div class="space-basic-bd1 mb-22 mt-16" v-if="chartType !== 'widget-card'"></div>
        <a-form-item class="mb-8" label="维度" v-if="chartType !== 'widget-funnel'">
          <a-select :maxTagCount="1" :maxTagTextLength="6" v-model="dimension" mode="multiple" :filter-option="false"
            placeholder="请选择也支持关键字搜索" @search="getDimensionList" @change="changeDimension" :open="dimensionOpen" 
            @dropdownVisibleChange="(open) => dimensionOpen = open" allowClear @blur="dimensionOpen = false" :disabled="norm.length>0&&chartType === 'widget-card'"
          >
            <a-select-option v-for="item in dimensionList" :key="item.field" :value="item.field" :disabled="choseOneFromMultiple(item.field)">
              <div :title="item.desc">{{ item.name }}</div>
            </a-select-option>
          </a-select>
        </a-form-item>
        <template v-if="chartType === 'widget-barlinechart'">
          <a-form-item label="折线指标" class="mb-8">
            <a-select v-model="lineNorm" :showSearch="true" :filter-option="false" placeholder="请选择" @search="getNormList" @change="changeLineNorm">
              <a-select-option   v-for="item in normList" :key="item.field" :value="item.field">
                <div :title="item.desc">{{ item.name }}</div>
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="柱状指标" class="mb-8">
            <a-select
              v-model="barNorm"
              :showSearch="true"
              :filter-option="false"
              placeholder="请选择"
              @search="getNormList"
            >
              <a-select-option   v-for="item in normList" :key="item.field" :value="item.field">
                <div :title="item.desc">{{ item.name }}</div>
              </a-select-option>
            </a-select>
          </a-form-item>
        </template>
        <a-form-item label="指标" class="mb-8" v-else>
          <a-select v-model="norm" mode="multiple" :open="normOpen" :maxTagCount="1" :maxTagTextLength="6" :disabled="dimension.length>0&&chartType === 'widget-card'" @dropdownVisibleChange="(open) => normOpen = open"  @blur="normOpen = false"
            :filter-option="false" placeholder="请选择" @search="getNormList" @change="changeNorm" allowClear
          >
            <a-select-option :disabled="isNormDisable(chartType, item, norm)" v-for="item in normList" :key="item.field" :value="item.field">
              <div :title="item.desc">{{ item.name }}</div>
            </a-select-option>
          </a-select>
        </a-form-item>
      </template>
      <!-- 多折线图 -->
      <template v-if="chartType === 'widget-linechart'">
        <a-form-item label="次坐标轴" class="mb-8">
          <a-select v-model="secondaryAxis" placeholder="请选择次坐标轴">
            <a-select-option v-for="item in secondaryAxisList" :key="item.field" :value="item.field">
              <div :title="item.desc">{{ item.name }}</div>
            </a-select-option>
          </a-select>
        </a-form-item>
      </template>
      <template v-if="['widget-barlinechart', 'widget-barchart', 'widget-linechart', 'widget-piechart'].indexOf(chartType) > -1">
        <div class="space-basic-bd1 mb-22 mt-24"></div>
        <a-form-item label="数据条数" class="mb-0 pb-0">
          <a-radio-group class="mt-6 mb-8" v-model="dataSize" style="line-height: 34px;">
            <a-radio :value="null">全部</a-radio>
            <a-radio :value="true">
              TOP
              <a-input-number v-if="dataSize" v-model="dataSizeNum" @change="dataSizeNumChange" :min="1" :style="{ width: 100, marginLeft: 10 }" />
            </a-radio>
          </a-radio-group>
        </a-form-item>
      </template>
      <TableColConfig @change="(value) => orders = value" :orders="orders" :filterList="filterList" v-if="chartType === 'widget-table'"></TableColConfig>
      <template v-if="['widget-table', 'widget-barchart', 'widget-linechart', 'widget-barlinechart', 'widget-funnel', 'widget-piechart'].indexOf(chartType) > -1">
        <div class="space-basic-bd1 mb-22 mt-24"></div>
        <a-form-item class="mb-8">
          <div slot="label">独立日期 
            <a-tooltip overlayClassName="question-tip" placement="topLeft" title="如果选择了独立日期，则该图表的数据不受统一日期控件的限制。" >
              <a-icon type="question-circle" />
            </a-tooltip>
          </div>
          <TagDateRange v-model="udfDate" :timeSelector="timeSelector" @change="handleTimeChange" allowClear>
            <template slot="tagLabel">
              <span style="font-size: 12px">动态日期：</span>
            </template>
          </TagDateRange>
        </a-form-item>
      </template>
      <a-form-item v-if="chartType === 'widget-table' ||  chartType == 'widget-barchart' ||
          chartType == 'widget-linechart' || chartType === 'widget-card'" class="mb-8">
        <div slot="label">数据计算</div>
        <div class="cont-diff">
          <a-radio v-model="calc.compare" @click.prevent="compareChange">对比</a-radio>
        </div>
        <div class="df">
          <a-select :allowClear="false" :disabled="!calc.compare" v-model="calc.compareType" placeholder="请选择对比数据范围">
            <a-select-option value="MoM">环比</a-select-option>
            <a-select-option value="YoY">同比</a-select-option>
            <a-select-option value="CUSTOMIZE">自定义</a-select-option>
          </a-select>
        </div>        
        <TagDateRange v-model="diffTimeSelector.date" :timeSelector="diffTimeSelector.timeSelector" @change="handleDiffTimeChange" allowClear v-if="calc.compareType === 'CUSTOMIZE'" :disabled="!calc.compare" style="margin-top: 10px;">
          <template slot="tagLabel">
            <span style="font-size: 12px">动态日期：</span>
          </template>
        </TagDateRange>
      </a-form-item>
      <a-form-item v-if="chartType === 'widget-table'" style="margin-top: 0;" class="mb-8">
        <div slot="label"></div>
        <div class="df">
          <div class="cont-diff" @click="handleTableDiff('difference')">
            <a-radio :checked="calc.difference">计算差值</a-radio>
          </div>
          <div class="cont-diff" @click="handleTableDiff('percentageDiff')">
            <a-radio :checked="calc.percentageDiff">计算差值百分比</a-radio>
          </div>
        </div>
        <div class="cont-diff" @click="handleTableDiff('summation')">
          <a-radio :checked="calc.summation">计算总和</a-radio>
        </div>
        <div class="cont-diff" @click="handleTableDiff('average')">
          <a-radio :checked="calc.average">计算平均值</a-radio>
        </div>
      </a-form-item>
      <a-form-item label="筛选条件" v-if="chartType !== 'widget-filter' && chartType !== 'screen'">
        <a-button class="ml--8" type="link" @click="filterClick"
          ><icon-font type="icon-plus-square" />添加筛选条件</a-button
        >
      </a-form-item>
    </a-form>
    <filter-condition
      ref="filterCondition"
      :dataSetValue="dataAuth.datasource || (dashbordData && dashbordData.datasource && dashbordData.datasource.mediaCode) || ''"
      :fields="dimension.concat(norm)"
      :tableId="getTableId"
      @save="conditionSave"
      v-if="conditionFlag"
    ></filter-condition>
  </div>
</template>
<script>
import {
  getDimensionList,
  getFieldsByCode,
  getNormList,
  getDataSource,
  getFields
} from "@/api/basicCyberData";
import Dictionary from "@/components/Dictionary/index";
import FilterCondition from "./filterCondition";
import TagDateRange from "@/components/TagDateRange";
import TableColConfig from "../table/tableColConfig.vue"
import DataAuth from "./dataAuth.vue"
import { mapGetters, mapState } from "vuex";

const initOrders = [
  {
    field: undefined,
    asc: true,
  }
]
export default {
  name: "DynamicComponents",
  components: {
    DataAuth,
    Dictionary,
    FilterCondition,
    TagDateRange,
    TableColConfig
  },
  model: {
    prop: "formData",
    event: "input",
  },
  props: {
    chartType: String,
    dictKey: String,
    formData: Object,
  },
  inject: ["getTimeRange", "getDashboardDynamicData", "widgetUpdate"],
  data() {
    return {
      dataAuth: {
        datasource: undefined,
        tableId: undefined,
        filterType: undefined,
        accountIds: [],
        collapseKey1: '1',
        collapseKey2: '1',
      },
      dataSet: [], // 数据源
      dimension: [],
      dimensionList: [],
      norm: [],
      barNorm: undefined,
      lineNorm: undefined,
      normList: [],
      params: {},
      chartProperties: {
        isVerified: this.isVerified,
        isDrag: false,
      },
      udfDate: [],
      timeSelector: '',
      conditions: [], // 筛选条件
      conditionFlag: true,
      // 表格相关
      filterList: [], //
      order: {
        field: "",
        asc: true,
      },
      orders: this.$deepclone(initOrders),
      // 表格对比
      calc: {
        compareType: undefined,
        compare: false,
        difference: false,
        percentageDiff: false,
        summation: false,
        average: false,
      },
      // 次坐标轴
      secondaryAxis: '',
      secondaryAxisList: [],
      dimensionOpen: false, // 维度下拉框展开
      normOpen: false, // 指标下拉框展开
      // 数据条数
      dataSize: null,
      dataSizeNum: 10,
      diffTimeSelector: {
        date: [],
        timeSelector: ''
      }
    };

  },
  watch: {
    formData: {
      handler(val) {
        this.echoDataSet(val);
      },
      deep: true,
    },
    dynamicDataRes: {
      handler(val) {
        // 依据返回的数据获取表头字段
        this.filterList = val.fields;
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      applyLoading: "applyLoading",
      isVerified: "isVerified",
      dynamicDataRes: "getDynamicDataRes",
    }),
    dashbordData() {
      return this.getDashboardDynamicData()?.contextData || {}
    },
  },
  async mounted() {
    this.echoDataSet(this.formData);
  },
  methods: {
    dataSizeNumChange(value) {
      this.dataSizeNum = value || 1
    },
    isNormDisable(chartType, item, norm){
      if(chartType === 'widget-table' || chartType === 'widget-barchart'  || chartType === 'widget-linechart'){
        return false;
      } else if(chartType === 'widget-funnel' && (!norm || norm.length <= 9)){
        return false;
      }  else if(!norm[0] || norm[0] === item.field){
        return false;
      } else {
        return true;
      }
    },
    // 表格特有对比切换
    handleTableDiff(keyName){
      this.calc[keyName] = !this.calc[keyName];
    },
    // 对比切换
    compareChange(){
      this.calc.compare = !this.calc.compare;
      if(this.calc.compare) {
        this.calc.compareType = 'MoM'
      }
    },
    // select 多选模式时，只能选一个
    choseOneFromMultiple(field){
      return this.chartType !== 'widget-table'&&this.dimension.length >= 1 && this.dimension[0] !== field
    },
    conditionSave(list) {
      this.conditions = list;
    },
    datachange() {
      this.clearOthers()
      this.getDimensionList();
      this.getNormList();
    },
    clearOthers() {
      this.dimension = [];
      this.norm = [];
      this.lineNorm = undefined
      this.barNorm = undefined
      this.filterList = [];
      this.conditions = [];
      this.conditionFlag = false;
      this.$nextTick(() => {
        this.conditionFlag = true;
      })
      this.order.field = "";
      this.orders = [
        {
          field: undefined,
          asc: true,
        }
      ];
    },
    async getDimensionList(keyWord) {
      this.dimensionList = []
      const params = {
        mediaCode: this.getMediaCode(),
        filterType: this.getFilterType()
      };
      const odata = {
        fields: this.dimension.concat(this.norm),
        orderFields: this.dimension.concat(this.norm),
        filterEnable: true,
        searchKeyWord: keyWord,
        tableId: this.getTableId() || undefined
      };
      const { code, data } = await getDimensionList(params, odata);
      if (code != "200") return;
      this.dimensionList = data && data.recordList ? data.recordList : [];
      // if(!keyWord || !keyWord.length){
      //   //非搜索状态才进行过滤 数据集变化时, 没有的维度会被清除
      //   this.dimension = this.dimension.filter(v => this.dimensionList.find(val => val.field == v))
      // }
    },
    getMediaCode(){
      return this.dataAuth.datasource || this.dashbordData?.datasource?.mediaCode
    },
    getTableId(){
      if(!this.dataAuth?.datasource) {
        return this.dataAuth.tableId || this.dashbordData?.tableId || ''
      }
      return this.dataAuth.tableId
    },
    getFilterType(){
      // if(!this.dataAuth.datasource && !this.dataAuth.tableId) {
        return this.dataAuth.filterType || this.dashbordData?.filterType
      // }
      // return this.dataAuth.filterType
    },
    async getNormList(keyWord) {
      this.normList= []
      const params = {
        mediaCode: this.getMediaCode(),
        filterType: this.getFilterType()
      };
      const odata = {
        fields: this.dimension.concat(this.norm),
        orderFields: this.dimension.concat(this.norm),
        filterEnable: true,
        searchKeyWord: keyWord,
        tableId: this.getTableId() || undefined
      };
      const { code, data } = await getNormList(params, odata);  
      this.normList = data?.recordList || [];
      // if(!keyWord || !keyWord.length){
      //   //非搜索状态才进行过滤
      //   //数据集变化时, 没有的指标会被清除
      //   if(this.norm)this.norm = this.norm?.filter(item => {
      //     for(const n of this.normList)if(n.field == item) return true
      //     return false
      //   })
      //   if(this.lineNorm&&!this.normList.find(v => v.field === this.lineNorm)) {
      //     this.lineNorm = undefined
      //   }
      //   if(this.barNorm&&!this.normList.find(v => v.field === this.barNorm)) {
      //     this.barNorm = undefined
      //   }
      // }
      if (code != "200") return;
    },
    async searchSortList(){
      if(this.getMediaCode()) {
        const { data } = await getFieldsByCode({
          code: this.getMediaCode(),
        }, {
          fields: this.dimension.concat(this.norm),
        });
        this.filterList = data?.recordList || [];
      } else {
        this.filterList = [];
      }
    },
    handleDiffTimeChange(val, timeSelector){
      this.diffTimeSelector.timeSelector = timeSelector;      
    },
    handleTimeChange(val, timeSelector){
      this.timeSelector = timeSelector;      
    },
    async loadDataSet() {
      const { code, data } = await getDataSource();
      this.dataSet = data;
      if (code != "200") return;
    },
    // 数据集回显
    async echoDataSet(val) {
      if (!val) return;
      const dataOptions = val && val.contextData ? val.contextData : {};
      await this.loadDataSet()
      let fun = () => {
        this.dimension = dataOptions.breakdownFields?[...dataOptions.breakdownFields]:[...(dataOptions.breakdowns || [])];
        this.conditions = JSON.parse(JSON.stringify(dataOptions.conditions || []));
        this.norm = [...(dataOptions.fields || [])];
        this.lineNorm = dataOptions.lineNorm || undefined;
        this.barNorm = dataOptions.barNorm || undefined;
        this.dataAuth.filterType = dataOptions.filterType || undefined;
        this.orders =  dataOptions.orders&& dataOptions.orders.length? [...dataOptions.orders] :  this.$deepclone(initOrders);
        if (this.dimension && this.dimension.length > 0 || this.dashbordData?.datasource) {
          this.getDimensionList();
        }
        if (this.norm && this.norm.length > 0 || this.dashbordData?.datasource) {
          this.getNormList();
        }
        if(this.orders && this.orders.length > 0 || this.dashbordData?.datasource){
          this.searchSortList();
        }
        this.$refs.dataAuth?.getTables()
        this.dateRang = { 
          ...this.dateRang,
          ...(dataOptions?.dateRang || {})
        };
        this.secondaryAxis = dataOptions.secondaryAxis;
        this.secondaryAxisList = dataOptions.secondaryAxisList;
        this.dataSize = dataOptions.dataSize?true:null
        this.dataSizeNum = dataOptions.dataSize || 10
        // 对比
        if(dataOptions.calc) {
          for(let key in this.calc) {
            this.calc[key] = dataOptions.calc[key] || false
          }
          this.calc.compareType = dataOptions.calc.compareType || undefined;
          if(dataOptions.calc.compareType === 'CUSTOMIZE'&&dataOptions?.dateRang) {
            this.diffTimeSelector.timeSelector = dataOptions.dateRang.diffTimeSelector || ''
            this.diffTimeSelector.date = [dataOptions.dateRang.diffFrom, dataOptions.dateRang.diffTo]
          }
        }
        // 组件本身日期回显
        if(dataOptions?.dateRang?.from && dataOptions?.dateRang.to){
          this.$set(this.udfDate, 0, dataOptions.dateRang.from)
          this.$set(this.udfDate, 1, dataOptions.dateRang.to)
          this.timeSelector = dataOptions.dateRang.timeSelector;
        }
      }
      this.dataAuth.datasource = dataOptions.datasource ? dataOptions.datasource.mediaCode : undefined;
      this.dataAuth.tableId = dataOptions.tableId;
      this.dataAuth.accountIds = [...(dataOptions.accountIds || [])];
      if (this.dataAuth.accountIds && this.dataAuth.accountIds.length > 0) {
        this.$refs.dataAuth?.handleSearchAccount("", [...dataOptions.accountIds]);
      } else if (this.getMediaCode()) {
        this.$refs.dataAuth?.handleSearchAccount("");
      }
      if(this.chartType!=='screen') {
        if(this.dashbordData?.datasource && !this.dataAuth.datasource && !this.dataAuth.tableId) {
          this.dataAuth.collapseKey1 = ''
        }
        if(this.dashbordData?.accountIds?.length && !this.dataAuth.datasource && !this.dataAuth.tableId) {
          this.dataAuth.collapseKey2 = ''
        }
      }
      fun()
    },
    // 改变维度时
    changeDimension(val) {
      if(this.chartType === 'widget-card' && this.norm.length) {
        this.$message.error('维度和指标不能同时填写！')
        this.dimension = []
        return
      }
      this.dimensionOpen = !this.choseOneFromMultiple()
      this.getDimensionList();
      this.getNormList();
      this.filterConditionList()
      this.filterOrders()
    },
    // 改变指标时
    changeNorm(val) {
      if(this.chartType === 'widget-card' && this.dimension.length) {
        this.$message.error('维度和指标不能同时填写！')
        this.norm = []
        return
      }
      this.normOpen = !(this.chartType == 'widget-card'&&this.norm.length >= 1)
      this.filterOrders()
      this.setSecondAxisList(val)
      this.filterConditionList()
      if(val.length > 1)  return ;
      this.getNormList();
      this.getDimensionList();
      // 多折线图时，切换指标，清空次坐标轴
      this.secondaryAxis = ''
    },
    filterOrders() {
      let arr = this.$deepclone(this.orders.filter(v => this.norm.find(k => k === v.field) || this.dimension.find(k => k === v.field)))
      this.orders = arr.length?arr:this.$deepclone(initOrders)
    },
    async setSecondAxisList(val){
      const params = {
        mediaCode: this.getMediaCode(),
      };
      const odata = {
        fields: this.dimension.concat(this.norm),
        orderFields: this.dimension.concat(this.norm),
        filterEnable: true,
      };
      const { code, data } = await getNormList(params, odata);  
      this.secondaryAxisList = this.$deepclone(data?.recordList.filter(item => val.find(val => val === item.field)) || []);
      if (code != "200") return;
    },
    changeLineNorm() {
      // this.handleEmitParentData();
      this.getNormList();
      this.getDimensionList();
      this.filterConditionList()
    },
    filterClick() {
      if (!this.dataAuth.datasource&&!this.dashbordData?.datasource?.mediaCode) {
        this.$message.error("请选择要分析的媒体名称！");
        return;
      }
      this.$nextTick(() => {
        this.$refs.filterCondition.init(this.conditions);
      });
    },
    getDataSourceObj() {
      return this.dataSet.filter((item) => item.mediaCode == this.dataAuth.datasource)[0];
    },
    // 提交参数及暴露给外部组件的参数；
    getSubmitData() {
      // 时间选择
      const dateRang = {
        from: this.udfDate && this.udfDate.length? this.udfDate[0] : "",
        to: this.udfDate && this.udfDate.length? this.udfDate[1] : "",
        timeSelector: this.timeSelector || undefined,
        ...this.calc.compareType === 'CUSTOMIZE'?{
          diffTimeSelector: this.diffTimeSelector.timeSelector,
          diffFrom: this.diffTimeSelector.date[0],
          diffTo: this.diffTimeSelector.date[1],
        }:{}
      };
      const order = { ...this.order };
      return {
        tableId: this.dataAuth.tableId || undefined,
        conditions: [...this.conditions],
        // 次坐标轴参数
        secondaryAxis: this.secondaryAxis,
        secondaryAxisList: this.secondaryAxisList,
        breakdowns: this.chartType === 'widget-card'?[]:[...this.dimension],
        breakdownFields: this.chartType === 'widget-card'?[...this.dimension]:undefined,
        fields: this.chartType === 'widget-barlinechart'?[this.barNorm, this.lineNorm].filter(v => v):[...this.norm],
        lineNorm: this.lineNorm,
        barNorm: this.barNorm,
        orders: this.$deepclone(this.orders.filter(v => v.field)),
        accountIds: [...this.dataAuth.accountIds],
        order: order && order.field ? order : null,
        datasource: this.getDataSourceObj(this.dataAuth.datasource),
        globalDateRang: this.getTimeRange(),
        filterType: this.dataAuth.filterType,
        dateRang,
        calc: { ...this.calc },
        pageNum: this.chartType === 'widget-table'?1:undefined,
        pageSize: this.chartType === 'widget-table'?10:undefined,
        dataSize: this.dataSize?this.dataSizeNum:null
      };
    },
    // 应用接口 列表需要带的数据
    handleEmitParentData(oparams = {}, isVerified = false) {
      // 是否调用apply接口 true调用
      this.chartProperties.isVerified = isVerified;
      const odata = this.getSubmitData();
      const params = {
        chartType: this.chartType,
        chartProperties: this.chartProperties,
        contextData: odata,
        widgetType: this.chartType,
        params: { ...oparams },
      };
      this.$emit("input", params);
      this.$emit("change", params);
    },
    applyData() {
      this.dimensionOpen = false
      if(this.formData.chartProperties) {
        this.formData.chartProperties.isDrag = false;
      }
      const params = {
        widgetType: this.chartType,
        all: true,
      };
      const dataParams = this.getSubmitData();
      if (!this.isVerfieldComp(dataParams, this.chartType)) return;
      if(this.chartType === 'widget-linechart') {
        this.widgetUpdate('setup', {
          isShow: this.norm.length <= 2
        })
      }
      this.handleEmitParentData(params, true);
    },
    // 组件的时间校验
    isVerfieldComp(dataParams, chartType) {
      const { globalDateRang, fields, calc, orders, dateRang, datasource, breakdownFields } = dataParams;
      if (chartType !== 'screen' && (!globalDateRang.from || !globalDateRang.to) && (!dateRang?.from || !dateRang?.to)) {
        this.$message.warning("请选择日期范围");
        return false;
      }
      if (chartType !== 'screen'&&(!datasource || datasource.length === 0)&&(!this.dashbordData?.datasource?.mediaCode)) {
        this.$message.warning("请选择要分析的媒体名称！");
        return false
      }
      if (calc.compareType === 'CUSTOMIZE' && !this.diffTimeSelector.date[0]) {
        this.$message.warning("自定义对比时间未选择");
        return false;
      }
      // 表格时，排序列校验
      if(orders && orders.length > 0) {
        let fields = orders.map(item => item.field)
        let isDuplicate = new Set(fields).size !== fields.length;
        if(isDuplicate) {
          this.$message.warning("所选排序列有重复");
          return false;
        }
      }
      let arr = ["widget-barchart", "widget-linechart", "widget-piechart", "widget-funnel", "widget-table", "widget-barlinechart"]
      if (arr.indexOf(chartType) > -1) {
        return this.barOrLineChartVerfieldFn(dataParams, chartType);
      } else if (chartType == "widget-card" && !fields.length && !breakdownFields.length) {
        this.$message.warning("缺乏必要查询条件");
        return false;
      } else {
        return true
      }
    },
    barOrLineChartVerfieldFn(dataParams, chartType) {
      const { breakdowns, fields, calc } = dataParams;
      if ((breakdowns.length === 0 && (chartType !== 'widget-table' && chartType !== 'widget-funnel')) || fields.length === 0) {
        this.$message.warning("缺乏必要查询条件");
        return false;
      } else if (calc.compare === true && !calc.compareType) {
        this.$message.warning("对比周期未选择");
        return false;
      }
      return true;
    },
    async filterConditionList() {
      const params = {
        mediaCode: this.getMediaCode()
      };
      const odata = {
        fields: this.dimension.concat(this.norm),
        filterEnable: true,
        searchKeyWord: undefined,
        pageSize: 10000,
        tableId: this.getTableId() || undefined
      };
      const { code, data } = await getFields(params, odata);
      let normList = data?.recordList || [];
      console.log(this.conditions)
      this.conditions = this.conditions.filter(v => normList.find(val => val.id === v.id))
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-collapse-header {
  padding-top: 6px!important;
  padding-bottom: 6px!important;
}
/deep/ .ant-collapse-content-box {
  padding: 8px!important;
}
/deep/ .ant-form-item {
  margin-bottom: 16px;
}
/deep/ .ant-form-item {
  .ant-form-item-label > label {
    color: #677392;
    font-weight: 400;
  }
}
/deep/ .question-tip{
  top: -60px;
}
.cont-diff{
  line-height: 32px;
}
</style>
